import React from "react";

export default function PaymentPage() {

  /* ================= LOAD RAZORPAY ================= */
  const loadRazorpay = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) return resolve(true);

      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  /* ================= CREATE ORDER ================= */
  const createOrder = async () => {
    const token = localStorage.getItem("token");

    const res = await fetch(
      "https://www.careplus.gopillz.com/razorpay/create-order/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!res.ok) throw new Error("Order creation failed");
    return res.json(); // { order_id, amount, key }
  };

  /* ================= VERIFY PAYMENT ================= */
  const verifyPayment = async (response) => {
    const token = localStorage.getItem("token");

    const res = await fetch(
      "https://www.careplus.gopillz.com/razorpay/verify/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
        }),
      }
    );

    if (!res.ok) throw new Error("Payment verification failed");
  };

  /* ================= RAZORPAY ================= */
  const handleRazorpay = async () => {
    try {
      const loaded = await loadRazorpay();
      if (!loaded) {
        alert("Razorpay SDK failed to load");
        return;
      }

      const order = await createOrder();

      const options = {
        key: order.key,
        amount: order.amount,        // 1500 (₹15)
        currency: "INR",
        order_id: order.order_id,    // ✅ ORDER BASED
        name: "ScanPlus Health",
        description: "Face Scan & Vitals Analysis",

        handler: async function (response) {
          await verifyPayment(response);
          localStorage.setItem("scanPaid", "true");
        //   setTimeout(() => {
        //     window.location.assign("/scan");
        //     // OR if using react-router:
        //     // navigate("/scan", { replace: true });
        //   }, 10);
        },
        modal: {
            ondismiss: function () {
              // ✅ iframe is FULLY closed now
              if (localStorage.getItem("scanPaid") === "true") {
                window.location.replace("/scan");
              }
            }
          },

        prefill: {
          name: localStorage.getItem("user_name"),
          contact: localStorage.getItem("patient_phone_number"),
        },

        theme: { color: "#4F46E5" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (err) {
      console.error(err);
      alert("Payment failed. Please try again.");
    }
  };

  /* ================= UI (UNCHANGED) ================= */
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4">
      <div className="w-full max-w-md bg-white/70 backdrop-blur-xl rounded-2xl shadow-2xl p-8 animate-scaleUp">

        <h2 className="text-2xl font-bold text-gray-900 text-center">
          Face Scan Payment
        </h2>

        <p className="text-gray-600 text-center mt-2">
          Complete payment to unlock AI-based vitals analysis
        </p>

        <div className="mt-6 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl p-6 text-center shadow-lg">
          <h3 className="text-4xl font-extrabold">₹15</h3>
          <p className="text-sm opacity-90 mt-1">One scan session</p>
        </div>

        <ul className="mt-6 space-y-3 text-sm text-gray-700">
          <li>✅ AI-based Heart & BP Scan</li>
          <li>✅ Takes less than 30 seconds</li>
          <li>✅ No wearable required</li>
        </ul>

        <div className="mt-8 space-y-4">
          <button
            onClick={handleRazorpay}
            className="w-full py-3 rounded-xl font-semibold text-white bg-[#4F46E5] hover:scale-[1.02] transition shadow-lg"
          >
            💳 Pay with Razorpay
          </button>
        </div>

        <p className="text-xs text-gray-500 text-center mt-4">
          🔒 Secure payments • Refund available if scan fails
        </p>
      </div>
    </div>
  );
}
